import Header from "../../../Components/Header";
import SingleSignOnSideBar from "../../../Components/SingleSignOnSideBar";
import AccrualChargesContainer from "./AccrualChargesContainer";

const AccrualReport = () => {
  return (
    <>
      <Header />
      <SingleSignOnSideBar />

      <main className="accrual-report">
        <div className="accrual-report_card">
          {/* Rendering this same component in dashboard reports also */}
          <AccrualChargesContainer />
        </div>
      </main>
    </>
  );
};

export default AccrualReport;
